import logo from "../../assets/images/logo-default.svg";
import * as API from "../../core/service/api_profile.js";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import CustomApp from "../../core/models/customApp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../core/feature/hooks";
import Company from "../../core/models/company";
export const ConfirmationVerifyMobile = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location: any = useLocation();
  const navigate = useNavigate();

  const [accounts, setAccounts] = useState<any>([]);
  const [user, setUser] = useState<any>(null);
  const [isMyAccount, setIsMyAccount] = useState(false);
  const [company, setCompany] = useState<Company>({} as Company);

  useEffect(() => {
    if (location.state && location.state.accounts) {
      setAccounts(location.state.accounts);
    }
    if (location.state && location.state.user) {
      setUser(location.state.user);
    }
  }, [location.state]);

  useEffect(() => {
    if (localStorage.getItem("company")) {
      const companyData = JSON.parse(localStorage.getItem("company") || "{}");
      setCompany(companyData);
    }
  }, []);

  const handleMerge = async () => {
    const data = {
      id: accounts[0]?.id,
      callerName: user.accounts[0].callerIdentities[0].name,
      callerId: user.accounts[0].callerIdentities[0].callerId,
      email: location.state?.email,
      phone: location.state?.phone,
      companyName: company.name,
    };
    console.log("state: ", data);
    dispatch(setLoading(true));
    try {
      const res = await API.mergeAccount(data, accounts[0]?.id);
      console.log("res merge: ", res);
      localStorage.setItem("merged", JSON.stringify(res));
      dispatch(setLoading(false));
      navigate("otp", {
        replace: true,
        state: {
          email: location.state?.email,
          phone: location.state?.phone,
        },
      });
    } catch (error) {
      console.error("Error merging account:", error);
      dispatch(setLoading(false));
    }
  };

  // const navigate = useNavigate();
  // const customApp: CustomApp = useAppSelector(
  //     (state) => state.customApp.customApp,
  // );
  return (
    <>
      <div className="min-h-screen font-montserrat h-full p-10 bg-psp-primary">
        <div className="mt-20">
          <img src={logo} className="w-52 mx-auto" />
        </div>
        <div className="mt-10 flex flex-col">
          <p className="font-semibold text-lg text-primary font-montserrat">
            {t("CONFIRMATIONVERIFY.title")}
          </p>
          <p className="font-medium text-sm">
            {t("CONFIRMATIONVERIFY.subtitle")}
          </p>
          <div className="bg-amber-100 rounded-md w-full mt-4 flex flex-row gap-2 items-center p-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="w-8 h-8 text-amber-900"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <div className="text-sm text-amber-900">
              {t("CONFIRMATIONVERIFY.security_warning")}
            </div>
          </div>
          <div className="bg-white rounded-md w-full p-2 text-sm mt-2 flex flex-col gap-2">
            <div className="flex flex-row justify-between items-center">
              <div>Name</div>
              <div className="font-medium">
                {accounts[0]?.callerName || "N/A"}
              </div>
            </div>
            <div className="flex flex-row justify-between items-center">
              <div>Sekolah</div>
              <div>{accounts[0]?.companyName || "N/A"}</div>
            </div>
            <div className="flex flex-row justify-between items-center">
              <div>email</div>
              <div>{accounts[0]?.email || "N/A"}</div>
            </div>
            <div className="flex flex-row justify-between items-center">
              <div>WhatApp</div>
              <div>{accounts[0]?.phone || "N/A"}</div>
            </div>
          </div>
          <div>
            <label
              htmlFor="isMyAccount"
              className="flex items-center space-x-2 mt-2 flex flex-row gap-2 items-center"
            >
              <input
                id="isMyAccount"
                type="checkbox"
                checked={isMyAccount}
                onChange={() => setIsMyAccount(!isMyAccount)}
              />
              {t("CONFIRMATIONVERIFY.checkbox_label")}
            </label>
          </div>
          <pre>{JSON.stringify(company, null, 2)}</pre>
          <div className=" flex flex-col gap-2 mt-8">
            <button
              onClick={() => handleMerge()}
              className="py-2 w-full bg-psp-btn-primary text-white rounded-md font-semibold font-poppins text-sm min-h-[5vh] hover:bg-blue-800 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={!isMyAccount}
            >
              {t("CONFIRMATIONVERIFY.buttons.submit")}
            </button>
            <button className="py-2 w-full border-2 border-psp-primary text-psp-primary rounded-md font-semibold font-poppins text-sm min-h-[5vh]">
              {t("CONFIRMATIONVERIFY.buttons.cancel")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
